import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

// icons + tooltip
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";

export default class Exams extends Component {
  state = {
    exams: [],
    per_page: 20,
    page_no: 1,
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    notiColor: "success",
    notification: false,
    message: "",
    loading: false,
  };

  componentDidMount() {
    this.getAllExams(this.state.page_no, this.state.per_page);
  }

  getAllExams = (page = 1, limit = 20) => {
    this.setState({ loading: true });

    if (init() !== "success") {
      this.setState({ loading: false });
      return;
    }

    axios
      .get(`${Constants.getUrls.getAllExams}?page=${page}&limit=${limit}`)
      .then((resp) => {
        if (resp.data?.status === "success") {
          // mongoose-paginate-v2 object
          const data = resp.data.data || {};
          const docs = data.docs || [];
          const currentPage = data.page || page || 1;
          const perPage = data.limit || limit || 20;
          const totalDocs = data.totalDocs || docs.length;
          const totalPages = data.totalPages || 1;
          const hasNextPage =
            typeof data.hasNextPage === "boolean" ? data.hasNextPage : currentPage < totalPages;
          const hasPrevPage =
            typeof data.hasPrevPage === "boolean" ? data.hasPrevPage : currentPage > 1;

          this.setState({
            exams: docs,
            pagination: {
              page: currentPage,
              totalPages,
              hasNextPage,
              hasPrevPage,
              nextPage: data.nextPage ?? (hasNextPage ? currentPage + 1 : null),
              prevPage: data.prevPage ?? (hasPrevPage ? currentPage - 1 : null),
              totalDocs,
              limit: perPage,
            },
            page_no: currentPage,
            loading: false,
          });
        } else {
          this.setState({
            notiColor: "warning",
            message: resp.data?.message || "Failed to load exams",
            notification: true,
            loading: false,
          });
          setTimeout(() => {
            this.setState({
              notification: false,
              message: "",
              notiColor: "success",
            });
          }, 3500);
        }
      })
      .catch((err) => {
        this.setState({
          notiColor: "warning",
          message: err?.response?.data?.message || "Something went wrong!",
          notification: true,
          loading: false,
        });
        setTimeout(() => {
          this.setState({
            notification: false,
            message: "",
            notiColor: "success",
          });
        }, 3500);
      });
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState(
      {
        per_page: newLimit,
      },
      () => {
        this.getAllExams(1, newLimit); // reset to first page with new limit
      }
    );
  };

  handlePageChange = (newPage) => {
    this.getAllExams(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this exam?")) return;

    if (init() !== "success") {
      return window.location.assign("/signin");
    }

    axios
      .delete(Constants.deleteUrls.deleteExam + id)
      .then((resp) => {
        this.setState(
          {
            notification: true,
            notiColor: "success",
            message: resp.data?.message || "Exam deleted",
          },
          () => {
            this.getAllExams(this.state.pagination.page, this.state.per_page);
          }
        );
        setTimeout(() => {
          this.setState({
            notification: false,
            message: "",
          });
        }, 2500);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Failed to delete exam",
        });
        setTimeout(() => {
          this.setState({
            notification: false,
            message: "",
          });
        }, 3500);
      });
  };

  handleToggleStatus = (id, currentStatus) => {
    if (init() !== "success") {
      return window.location.assign("/signin");
    }

    axios
      .put(Constants.putUrls.toggleExamStatus + "/" + id)
      .then((resp) => {
        this.setState(
          {
            notification: true,
            notiColor: "success",
            message: resp.data?.message || `Exam status changed`,
          },
          () => {
            this.getAllExams(this.state.pagination.page, this.state.per_page);
          }
        );
        setTimeout(() => {
          this.setState({ notification: false, message: "" });
        }, 2500);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Failed to toggle status",
        });
        setTimeout(() => {
          this.setState({
            notification: false,
            message: "",
          });
        }, 3500);
      });
  };

  formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return "-";
    return d.toLocaleDateString();
  };

  render() {
    const { exams, loading, pagination } = this.state;

    return (
      <div>
        <DashboardLayout>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Competitive Exams
                </MDTypography>
              </MDBox>

              <Grid item sm={4} px={2} align="right" style={{ padding: 16 }}>
                <Link to="/addexams">
                  <MDButton variant="contained" size="small" color="primary">
                    Create New
                  </MDButton>
                </Link>
              </Grid>

              <MDBox py={3}>
                {loading ? (
                  <MDBox>
                    <Grid align="center">
                      <h4>Loading...</h4>
                    </Grid>
                  </MDBox>
                ) : (
                  <>
                    {exams.length > 0 ? (
                      <DataTable
                        table={{
                          columns: [
                            { Header: "serial", accessor: "serial", width: "6%" },
                            { Header: "exam name", accessor: "exam_name" },
                            { Header: "date", accessor: "exam_date" },
                            { Header: "type", accessor: "exam_type" },
                            { Header: "venue", accessor: "exam_venue" },
                            { Header: "status", accessor: "status" },
                            { Header: "poster", accessor: "poster" },
                            { Header: "action", accessor: "action" },
                          ],
                          rows: exams.map((exam, index) => {
                            const status = exam?.status || "inactive";
                            const isActive = status === "active";

                            return {
                              serial: (pagination.page - 1) * pagination.limit + (index + 1),
                              exam_name: exam?.exam_name,
                              exam_date: this.formatDate(exam?.exam_date),
                              exam_type: exam?.exam_type,
                              exam_venue: exam?.exam_venue || "-",
                              status: (
                                <Tooltip
                                  title={isActive ? "Click to deactivate" : "Click to activate"}
                                  placement="top"
                                >
                                  <IconButton
                                    size="small"
                                    onClick={() => this.handleToggleStatus(exam._id, status)}
                                    style={{
                                      color: isActive ? "green" : "gray",
                                    }}
                                  >
                                    <PowerSettingsNewIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              ),
                              poster: exam?.exam_poster ? (
                                <img
                                  src={Constants.imageDomain + exam.exam_poster}
                                  alt="Exam Poster"
                                  style={{
                                    height: "80px",
                                    width: "180px",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                "-"
                              ),
                              action: (
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "center",
                                  }}
                                >
                                  {/* Edit */}
                                  <Tooltip title="Update Exam" placement="top">
                                    <Link
                                      to={{
                                        pathname: "/updateExams/" + exam._id,
                                        state: { data: exam },
                                      }}
                                    >
                                      <IconButton size="small" color="info">
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                    </Link>
                                  </Tooltip>

                                  {/* Delete */}
                                  <Tooltip title="Delete Exam" placement="top">
                                    <IconButton
                                      size="small"
                                      color="error"
                                      onClick={() => this.handleDelete(exam._id)}
                                    >
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                              ),
                            };
                          }),
                        }}
                        entriesPerPage={{ defaultValue: this.state.per_page }}
                        page_no={pagination.page}
                        totalPages={pagination.totalPages}
                        hasNextPage={pagination.hasNextPage}
                        hasPrevPage={pagination.hasPrevPage}
                        isnextPage={pagination.nextPage}
                        prevPage={pagination.prevPage}
                        totalDocs={pagination.totalDocs}
                        onPageChange={this.handlePageChange}
                        onEntriesPerPageChange={this.handleEntriesPerPageChange}
                      />
                    ) : (
                      <div style={{ padding: 16 }}>No Data Found!</div>
                    )}
                  </>
                )}
              </MDBox>

              <MDSnackbar
                color={this.state.notiColor}
                icon="notifications"
                title="Exams Admin"
                content={this.state.message}
                dateTime="Just now"
                open={this.state.notification}
              />
            </Card>
          </MDBox>
        </DashboardLayout>
      </div>
    );
  }
}
